import React, { useContext, useState } from "react";
import "./style/BookPreview.css";
import { Context, BasketContext } from "../components/context/Context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faStarHalf } from "@fortawesome/free-solid-svg-icons";

function BookPreview() {
  const [book, setBook] = useContext(Context);
  const [rate, setRate] = useState(parseInt(book?.rating));
  const [basket, setBasket] = useContext(BasketContext);

  const addToBasket = () => {
    setBasket([
      ...basket,
      { id: book?.id, title: book?.title, prix: book?.prix, src: book?.src },
    ]);
  };

  return (
    <div className="bookPreview">
      <img src={book?.src} alt="book cover" />
      <div className="bookPreview__info">
        <h3>{book?.title ? book.title : "wating for title"}</h3>
        <h5>
          {book.author?.length > 1
            ? book.author.map((author) => {
                return author + " & ";
              })
            : book.author}
        </h5>
        <div className="rating">
          {rate ? (
            Array(rate)
              .fill()
              .map((_, i) => {
                return <FontAwesomeIcon icon={faStar} key={i} />;
              })
          ) : (
            <p>rating not availble</p>
          )}
          {book.rating > rate && book.rating ? (
            <FontAwesomeIcon icon={faStarHalf} />
          ) : (
            ""
          )}
        </div>
        <p className="prix">
          {book.prix === "FREE" ? book.prix : "$" + book.prix}
        </p>
        <p className="desc">
          {book.desc ? book.desc : "description not available"}
        </p>
        <div className="btn" onClick={addToBasket}>
          {" "}
          Add to basket
        </div>
      </div>
    </div>
  );
}

export default BookPreview;
